import React, {Component} from 'react';
import {createSelector} from 'reselect';
import {connect} from 'react-redux';
import {bindDispatch} from 'app/utils/redux';

import CandidatesView from 'views/candidates';

class CandidatesContainer extends Component {

	render() {
		let {candidates, sessions, actions} = this.props;
		return (
			<div className='mx2 my1 container'>
			  <CandidatesView 
			  	candidates={candidates}
			  	sessions={sessions}
          updateFilter={actions.updateFilter}
          fetchCandidates={actions.fetchCandidates}
          fetchReport={actions.fetchReport}/>
			</div>
		);
	}
}

const selector = createSelector(
  state => state.candidates,
  state => state.sessions,
  (candidates, sessions) => ({ candidates, sessions })
);

export default connect(selector, bindDispatch)(CandidatesContainer);



// WEBPACK FOOTER //
// ./src/containers/candidates/CandidatesContainer.js